module.exports = __webpack_public_path__ + "static/media/transaction.43e7b178.svg";